import { EntityState } from '@ngrx/entity';
import { ColumnNote } from '../../../../models/locations-models/column-note';
import { addressTranslationsAdapter, columnNotesAdapter, locationsAdapter } from './location-list-adapters';
import { GbpLocationGroup } from '../../../../models/locations-models/gbp-location-group';
import { OngoingActionsEnum } from '../../enums/ongoing-actions';
import { Location } from '../../../../models/locations-models/location';
import { LocationAddressTranslation } from '../../../../models/locations-models/location-address-translation';
import { DatasourceSyncDetails } from '../../../../models/datasource-sync-details';
import { MAX_LOCATION_BATCH } from '../../constants';
import { CCSyncDetails } from '../../../../models/locations-models/cc-sync-details';
import { CoordinateHistory } from '../../../../models/coordinate-history';
import { BulkValidationDetails } from '../../../../models/bulk-validation-details';

// Types
export interface Locations extends EntityState<Location> {
}

export interface AddressTranslations extends EntityState<LocationAddressTranslation> {
}

export interface ColumnNotesState extends EntityState<ColumnNote> {
}

export interface LocationListState {
  // BE data
  locations: Locations,
  addressTranslations: AddressTranslations,
  gbpLocationGroups: GbpLocationGroup[],
  activeDataConnections: string[], // the green bubble
  columnNotes: ColumnNotesState;
  countryISO2List: string[] // options to choose from for the country filter
  datasourceSyncDetails: DatasourceSyncDetails,
  ccSyncDetails: CCSyncDetails,
  bulkValidationDetails: BulkValidationDetails,
  validationHistory: CoordinateHistory[],
  // shared UI data
  focusedRowId: number,
  hoveredRowId: number,
  selectedRowsIds: number[],
  // loading states
  loading: boolean,   // activates a loading spinner overlay where the user is not able to interact with the UI
  validationHistoryLoading: boolean,
  // any value in here will result in rendering a loading bar above the location list table
  ongoingActions: OngoingActionsEnum[],  // stuff in here activates a loading bar in the action bar
  // pageSize param used to get locations successfully
  lastSuccessfulPageSize: number
}

// Initial State

export const initialState: LocationListState = {
  locations: locationsAdapter.getInitialState({}),
  addressTranslations: addressTranslationsAdapter.getInitialState({}),
  gbpLocationGroups: [],
  activeDataConnections: [],
  columnNotes: columnNotesAdapter.getInitialState(),
  countryISO2List: [],
  datasourceSyncDetails: null,
  ccSyncDetails: null,
  bulkValidationDetails: null,
  validationHistory: [],
  focusedRowId: null,
  hoveredRowId: null,
  selectedRowsIds: [],
  loading: false,
  validationHistoryLoading: false,
  ongoingActions: [],
  lastSuccessfulPageSize: MAX_LOCATION_BATCH
};

